module.exports = __webpack_public_path__ + "img/tjt_down.8026b7be.png";